module.exports = __webpack_public_path__ + "img/1_mn6bOs7s6Qbao15PMNRyOA-min.4c04fa03.png";